import { styled } from "@mui/material/styles";
import Tab from "@mui/material/Tab";

export const StyledTab = styled(Tab)(({ theme }) => ({
  height: 48,
  minWidth: 40,
  padding: "12px 0",

  [theme.breakpoints.up("sm")]: {
    minWidth: 60,
    padding: "12px 16px",
  },

  [theme.breakpoints.up("md")]: {
    minWidth: 80,
  },

  [theme.breakpoints.up("lg")]: {
    minWidth: 100,
  },
}));
